import React, { Component, Fragment } from "react";

import Immutable, { is } from "immutable";

import * as XLSX from 'xlsx';

import axios from "axios";

import { Table, Container, Row, InputGroup, Col, Navbar, NavbarBrand, Nav, NavItem, NavLink, Card, CardBody, CardTitle, CardSubtitle, CardText, Button, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, ButtonGroup, FormGroup, Label, Input } from "reactstrap";
import moment from "moment";
import HeaderComponent from "../header/HeaderComponent";
import TagComponent from "../element/TagComponent";
import TaskComponent from "../element/TaskComponent";

import LoadingScreen from "../element/LoadingScreen";
import '../../css/ImageTable.css';
const { Base64 } = require("js-base64");


class ProductPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      project_name: "mtest",
      data: [],
      project_list: [],
      selectedProjectName: "",
      isModalOpen: false,
      modalImageSrc: '',
      isRejctModelOpen: false,
      rejectTargetIdx: undefined,
      rejectReason: "",
      currentRejectReason: "",
      search_seq: "",
      modalImageSrc2: '',
      leftCount: -1,
      currentCheckTag: "featured",
      onDownloadAll: false,
      currentDownloadUrl: "",
      possbileTagList: [],
      taskTags: [],
      newTagName: "",
      newTagContent: "",
      currentTagIdx: -1,
      taskList: [],
      selectedMode: "all",
      currentSelectedTask: undefined,
      statusCounts: {
        reject: 0,
        success: 0,
        accept: 0,
        hold: 0,
        ready: 0
      },
      mixModalOpen: false,
      mixModelSrc: "",
      mixModelSeq: "",
      currentProject: undefined,

    };
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.modalRef = React.createRef();
    window.that = this;
  }



  handleKeyPress(event) {
    switch (event.key.toLowerCase()) {

    }
  }



  handleClickOutside = (event) => {

    if (this.modalRef.current && !this.modalRef.current.contains(event.target)) {
      this.closeModal();
    }
  };
  loadMixModel = async (seq) => {

    if (seq == "") {
      alert("모델 시퀀스를 입력해주세요.");
      return;
    }


    this.setState({
      mixModelSrc: `${process.env.REACT_APP_API_PATH}/${process.env.REACT_APP_STAGE}/admin/task/image?seq=${seq}&type=model`,
    });

  }

  closeMixModal = () => {

    this.setState({ mixModalOpen: false });
  };
  mixModalOpen = () => {
    this.setState({ mixModalOpen: true });
  }
  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
    window.removeEventListener("keydown", this.handleKeyPress);
  }


  async componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
    this.getProjectList();


    window.addEventListener("keydown", this.handleKeyPress);



  }
  getPossbleTagList = async () => {
    const result = await axios({
      method: "Get",
      url: `${process.env.REACT_APP_API_PATH}/${process.env.REACT_APP_STAGE}/admin/tag`,
      params: {

      },
      headers: {
        Authorization: this.props.cognito.user.signInUserSession.idToken.jwtToken,
      },
    });
    const tag_list = JSON.parse(result.data.body).tag_list;
    tag_list.sort((a, b) => {
      return a.name.localeCompare(b.name);
    });
    this.setState({ possbileTagList: tag_list, currentTagIdx: tag_list[0].idx }, () => {


    });
  }

  updateProductStatus = async (productIdx, status) => {

    this.setState({ isLoading: true })
    try {
      await axios({
        method: "Put",
        url: `${process.env.REACT_APP_API_PATH}/${process.env.REACT_APP_STAGE}/charan/project/product`,
        data: {
          product_idx: productIdx + "",
          check_status: status

        },
        headers: {
          Authorization: this.props.cognito.user.signInUserSession.idToken.jwtToken,
        },
      });
    } catch (e) {
      alert(e);
      this.setState({ isLoading: false })
      return;
    }

    this.setState((prevState) => ({
      data: prevState.data.map((item) => {
        if (item.idx === productIdx) {


          return {
            ...item,
            customer_check_status: status,
          }
        }
        return item;

      }),
      currentItem: {
        ...prevState.currentItem,
        customer_check_status: status
      },
      isLoading: false
    }));
    this.getProductData();

  };
  getProjectList = async () => {
    const result = await axios({
      method: "Get",
      url: `${process.env.REACT_APP_API_PATH}/${process.env.REACT_APP_STAGE}/charan/project/list`,
      params: {


      },
      headers: {
        Authorization: this.props.cognito.user.signInUserSession.idToken.jwtToken,
      },
    });
    const projects = JSON.parse(result.data.body).project_list;
    projects.unshift({ project_name: "프로젝트 선택" })
    const searchParams = new URLSearchParams(window.location.search);
    const projectName = searchParams.get("project_name");

    this.setState({
      project_list: projects,
      selectedProjectName: (projectName) ? projectName : "all"
      //selectedProjectName: "rlabs_241118"
    }, () => {


      this.getProductData();

    });
  }

  getProductData = async () => {
    if (this.state.selectedProjectName == "") {
      return;
    }
    const result = await axios({
      method: "Get",
      url: `${process.env.REACT_APP_API_PATH}/${process.env.REACT_APP_STAGE}/charan/project/product`,
      params: {
        project_name: this.state.selectedProjectName,
        // random_one: "true",

      },
      headers: {
        Authorization: this.props.cognito.user.signInUserSession.idToken.jwtToken,
      },
    });
    const tasks = JSON.parse(result.data.body).tasks;
    const project = JSON.parse(result.data.body).project;

    const leftCount = JSON.parse(result.data.body).left_count;

    //if task item has discard field and if its true, set discarded to true
    tasks.forEach((task) => {
      if (task.discard && task.discard == "true") {
        task.discarded = true;
      }
    });

    const statusCounts = {
      reject: 0,
      success: 0,
      accept: 0,
      hold: 0,
      ready: 0
    };
    tasks.forEach(item => {
      if (statusCounts.hasOwnProperty(item.customer_check_status)) {
        statusCounts[item.customer_check_status]++;
      }
    });


    //set to state
    if (tasks[0] == undefined) {
      this.setState({ statusCounts: statusCounts, data: tasks, leftCount: leftCount, isModalOpen: false });
    }
    else {
      this.setState({ currentProject: project, statusCounts: statusCounts, data: tasks, currentItem: tasks[0], leftCount: leftCount, isModalOpen: false, modalImageSrc: this.generateImageUrl(tasks[0]), modalImageSrc2: this.generateResultUrl(tasks[0]) }, () => {

      });
    }
  }
  generateImageUrl(item, thumnail) {
    if (!item) {
      return "";
    }
    if (thumnail) {
      return `${process.env.REACT_APP_API_PATH}/${process.env.REACT_APP_STAGE}/public/download/image?project_name=${item.project_name}&seq=${item.seq1}&type=input&version=${item.version}&width=500&height=500`

    }
    return `${process.env.REACT_APP_API_PATH}/${process.env.REACT_APP_STAGE}/public/download/image?project_name=${item.project_name}&seq=${item.seq1}&type=input&version=${item.version}`
  }

  generateModelUrl(item, thumnail) {
    if (!item) {
      return "";
    }
    if (thumnail) {
      return `${process.env.REACT_APP_API_PATH}/${process.env.REACT_APP_STAGE}/public/download/image?project_name=${item.project_name}&seq=${item.seq}&type=output&version=${item.version}&width=500&height=500`
    }
    return `${process.env.REACT_APP_API_PATH}/${process.env.REACT_APP_STAGE}/public/download/image?project_name=${item.project_name}&seq=${item.seq}&type=output&version=${item.version}`
  }

  generateResultUrl(item, thumnail) {
    if (!item) {
      return "";
    }
    if (thumnail) {
      return `${process.env.REACT_APP_API_PATH}/${process.env.REACT_APP_STAGE}/public/download/image?project_name=${item.project_name}&seq=${item.seq1}&type=output&width=500&height=500`
    }
    return `${process.env.REACT_APP_API_PATH}/${process.env.REACT_APP_STAGE}/public/download/image?project_name=${item.project_name}&seq=${item.seq1}&type=output&noresize=1&small=1`
  }

  setCurrentSelectedTask = (task) => {
    this.setState({ currentSelectedTask: task });
  }

  // Open modal if Ctrl is pressed when clicking on result image
  handleResultClick = (item) => {

    let url = "";

    this.setState({ currentItem: item, isModalOpen: true, modalImageSrc: this.generateImageUrl(item), modalImageSrc2: this.generateResultUrl(item) }, () => {
      this.getProductTask(item.seq1);
    },);

  };
  getProductTask = async (seq) => {
    const result = await axios({
      method: "Get",
      url: `${process.env.REACT_APP_API_PATH}/${process.env.REACT_APP_STAGE}/charan/project/product/task`,
      params: {
        seq: seq,

      },
      headers: {
        Authorization: this.props.cognito.user.signInUserSession.idToken.jwtToken,
      },
    });
    const task = JSON.parse(result.data.body).task;

    this.setState({ currentSelectedTask: task });

  }
  // Close the modal
  closeModal = () => {

    this.setState({ isModalOpen: false, modalImageSrc: '', isRejctModelOpen: false, rejectTargetIdx: undefined, isShowRejectReasonOpen: false });
  };



  onValueChanged = (name, value) => {

    console.log("name:", name, ",value:", value)

    this.setState({
      [name]: value

    }, () => {
      if (name == "selectedProjectName") {
        this.getProductData();
      }
    });

  };
  toggleExcludeEvaluated = () => {
    // Toggle excludeEvaluated state
    this.setState((prevState) => ({
      excludeEvaluated: !prevState.excludeEvaluated
    }));
  };
  updateCheckStatus = async (seq, version) => {

    await axios({
      method: "Put",
      url: `${process.env.REACT_APP_API_PATH}/${process.env.REACT_APP_STAGE}/admin/eval`,
      data: {
        seq: seq,


      },
      headers: {
        Authorization: this.props.cognito.user.signInUserSession.idToken.jwtToken,
      },
    });
    alert("재평가 요청이 완료되었습니다.");

  };

  updateMainTask = async (productIdx, seq) => {

    try {
      await axios({
        method: "Post",
        url: `${process.env.REACT_APP_API_PATH}/${process.env.REACT_APP_STAGE}/admin/project/product/update`,
        data: {
          product_idx: productIdx + "",
          seq: seq

        },
        headers: {
          Authorization: this.props.cognito.user.signInUserSession.idToken.jwtToken,
        },
      });
    } catch (e) {
      //alert(e)
      return;
    }

    this.setState((prevState) => ({
      data: prevState.data.map((item) => {
        if (item.idx === productIdx) {


          return {
            ...item,
            seq1: seq,
          }
        }
        return item;

      }),
      currentItem: {
        ...prevState.currentItem,
        seq1: seq
      }
    }));

  };
  downloadAll = async () => {
    if (this.state.onDownloadAll) {
      window.open(this.state.currentDownloadUrl, '_blank')
      this.setState({ onDownloadAll: false, currentDownloadUrl: undefined })
      return;
    }
    if (this.state.selectedProjectName == "all") {
      alert("다운로드 받을 프로젝트를 선택해주세요.");
      return;
    }
    if (this.state.currentProject.check_status != "completed") {
      if (!window.confirm("전체 다운로드를 진행하시겠습니까? 해당 프로젝트가 완료 상태로 전환되며 이미지를 다운로드 합니다.(완료 상태로 전환된 프로젝트는 검수 상태 변경이 불가능합니다.)")) {
        return;
      }

    }



    this.setState({ onDownloadAll: true, downloadProgress: "다운로드 준비 중..." })

    // 단일 zip(비동기): start → status 폴링 → 완성되면 zip 1개 다운로드. 대용량(수백장)도 30초 벽 없이.
    // (ProductAllPage 와 동일 패턴. 백엔드가 fallback:true 주면 기존 청크 경로로 자동 전환.)
    const projectName = this.state.selectedProjectName;
    const authHeader = { Authorization: this.props.cognito.user.signInUserSession.idToken.jwtToken };
    const DOWNLOAD_BASE = process.env.REACT_APP_PROJECT_DOWNLOAD_ALL;
    try {
      const startRes = await axios({ method: 'POST', url: `${DOWNLOAD_BASE}/start`, params: { project_name: projectName }, headers: authHeader });
      const startData = JSON.parse(startRes.data.body);
      if (!startData.fallback) {
        for (let i = 0; i < 100; i++) {
          let url = startData.state === 'ready' ? startData.downloadUrl : null;
          if (!url) {
            // eslint-disable-next-line no-await-in-loop
            const stRes = await axios({ method: 'GET', url: `${DOWNLOAD_BASE}/status`, params: { project_name: projectName }, headers: authHeader });
            const st = JSON.parse(stRes.data.body);
            if (st.state === 'ready') url = st.downloadUrl;
          }
          if (url) {
            const link = document.createElement('a');
            link.href = url; link.download = `${projectName}.zip`; link.style.display = 'none';
            document.body.appendChild(link); link.click(); document.body.removeChild(link);
            this.setState({ onDownloadAll: false, downloadProgress: "", currentDownloadUrl: url });
            return;
          }
          this.setState({ downloadProgress: `압축파일 생성 중... (${i * 3}초)` });
          // eslint-disable-next-line no-await-in-loop
          await new Promise((r) => setTimeout(r, 3000));
        }
        alert("압축파일 생성이 오래 걸립니다. 잠시 후 다시 눌러주세요.");
        this.setState({ onDownloadAll: false, downloadProgress: "" });
        return;
      }
    } catch (e) {
      console.log('single-zip 실패, 청크로 폴백:', e);
    }

    // 폴백: 100장씩 여러 zip (기존 동작).
    const CHUNK = 100;
    try {
      const parts = [];
      let offset = 0, total = null, partIndex = 0;
      do {
        // eslint-disable-next-line no-await-in-loop
        const res = await axios({ method: 'GET', url: `${DOWNLOAD_BASE}`, params: { project_name: projectName, check_status: "accept", offset, limit: CHUNK }, headers: authHeader });
        const responseData = JSON.parse(res.data.body);
        if (total === null) total = responseData.totalAccepted || 0;
        partIndex += 1;
        this.setState({ downloadProgress: `파트 준비 중 ${partIndex}...` });
        if (responseData.downloadUrls && Array.isArray(responseData.downloadUrls)) { for (const u of responseData.downloadUrls) parts.push(u); }
        offset += CHUNK;
      } while (offset < (total || 0));
      if (!parts.length) { alert("다운로드할 파일이 없습니다."); this.setState({ onDownloadAll: false, downloadProgress: "" }); return; }
      for (let i = 0; i < parts.length; i++) {
        const link = document.createElement('a');
        link.href = parts[i].url; link.download = parts[i].fileName || `${projectName}-part${i + 1}.zip`; link.style.display = 'none';
        document.body.appendChild(link); link.click(); document.body.removeChild(link);
        // eslint-disable-next-line no-await-in-loop
        await new Promise((r) => setTimeout(r, 800));
      }
      this.setState({ onDownloadAll: false, downloadProgress: "" });
    } catch (e) {
      alert("다운로드 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.");
      console.log(e);
      this.setState({ onDownloadAll: false, downloadProgress: "" });
    }

  };
  exportToExcel = async () => {
    if (this.state.currentProject.check_status != "completed") {
      if (!window.confirm("전체 다운로드를 진행하시겠습니까? 해당 프로젝트가 완료 상태로 전환되며 이미지를 다운로드 합니다.(완료 상태로 전환된 프로젝트는 검수 상태 변경이 불가능합니다.)")) {
        return;
      }
    }
    try {
      const downloadResult = await axios({
        method: 'GET',
        url: `${process.env.REACT_APP_API_PATH}/${process.env.REACT_APP_STAGE}/charan/project/download/excel`,
        params: {
          project_name: this.state.selectedProjectName,


        },
        headers: {
          Authorization: this.props.cognito.user.signInUserSession.idToken.jwtToken,
        },

      });
      const url = JSON.parse(downloadResult.data.body).downloadUrl;

      window.open(url)
      // this.setState({ currentDownloadUrl: url })
      //this.setState({ onDownloadAll: false })
    }
    catch (e) {
      alert("파일 키가 없거나 올바른 요청이 아닙니다.")
      console.log(e)
    }



  };
  getCurrentStatus = (status) => {
    if (status == "accept") {
      return (<span style={{ fontWeight: "bold", color: "green" }}>수락</span>)
    }
    else if (status == "hold") {
      return (<span style={{ fontWeight: "bold", color: "orange" }}>보류</span>)
    }
    else if (status == "reject") {
      return (<span style={{ fontWeight: "bold", color: "red" }}>제외</span>)
    }
    else {
      return (<span style={{ fontWeight: "bold", color: "purple" }}>검수 전</span>)
    }
  }
  getCurrentTile = (status) => {
    if (status == "accept") {
      return (<h2 style={{ fontWeight: "bold", color: "green" }}>현재상태 : 수락</h2>)
    }
    else if (status == "hold") {
      return (<h2 style={{ fontWeight: "bold", color: "orange" }}>현재상태 : 보류</h2>)
    }
    else if (status == "fail") {
      return (<h2 style={{ fontWeight: "bold", color: "red" }}>현재상태 : 실패</h2>)
    }
    else {
      return (<h2 style={{ fontWeight: "bold", color: "purple" }}>현재상태 : 검수 전</h2>)
    }
  }
  render() {
    let filteredData = this.state.data;
    if (this.state.selectedMode == "accept") {
      filteredData = this.state.data.filter(item => item.customer_check_status == 'accept');
    }
    if (this.state.selectedMode == "hold") {
      filteredData = this.state.data.filter(item => item.customer_check_status == 'hold');
    }
    if (this.state.selectedMode == "ready") {
      filteredData = this.state.data.filter(item => item.customer_check_status == 'ready');
    }
    if (this.state.selectedMode == "reject") {
      filteredData = this.state.data.filter(item => item.customer_check_status == 'reject');
    }

    return (
      <Fragment>
        <LoadingScreen isLoading={this.state.isLoading} />
        {this.state.isModalOpen && (
          <div className="modals"
            zIndex={1500}
            style={{

            }} >
            <div className="modal-contents" ref={this.modalRef} style={{ width: "95%", }}>
              <div style={{ width: "100%", fontSize: 25, color: "black", fontWeight: 800, justifyContent: "center", textAlign: "center", marginBottom: "5px" }}></div>

              <div style={{
                width: "100%", display: "flex",

                "justify-content": "space-between"
              }}>
                <img onClick={() => { this.closeModal() }} style={{
                  display: "block",
                  "margin-left": "auto",
                  "margin-right": "auto",
                  "object-fit": "contain",
                  "max-height": 800,
                  "max-width": 500
                }} src={this.state.modalImageSrc} alt="Large version" className="modal-image" />

                {/* <TaskComponent item={this.state.currentSelectedTask}></TaskComponent> */}
                <img onClick={() => { this.closeModal() }} style={{
                  display: "block",
                  "margin-left": "auto",
                  "margin-right": "auto",
                  "object-fit": "contain",
                  "max-height": 800
                }} src={this.state.modalImageSrc2} alt="Large version" className="modal-image" />
                <div>
                  <table style={{ width: "100%", border: "1px solid black", "border-collapse": "collapse" }}>
                    <thead>
                      <tr>
                        <th style={{ width: "70%" }}>Prop</th>
                        <th style={{ width: "50%" }}>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="tb_td">ProductId</td>
                        <td className="tb_td">{this.state.currentSelectedTask?.product_id}</td>
                      </tr>
                      <tr>
                        <td className="tb_td">seq</td>
                        <td className="tb_td">{this.state.currentSelectedTask?.seq}</td>
                      </tr>
                      <tr>
                        <td className="tb_td">카테고리</td>
                        <td className="tb_td">{this.state.currentSelectedTask?.category_1}</td>
                      </tr>
                      <tr>
                        <td className="tb_td">Total</td>
                        <td className="tb_td">{this.state.currentSelectedTask?.size_total}</td>
                      </tr>
                      <tr>
                        <td className="tb_td">Hip</td>
                        <td className="tb_td">{this.state.currentSelectedTask?.size_hip}</td>
                      </tr>

                      <tr>
                        <td className="tb_td">Waist</td>
                        <td className="tb_td">{this.state.currentSelectedTask?.size_waist}</td>
                      </tr>
                      <tr>
                        <td className="tb_td">Breast</td>
                        <td>{this.state.currentSelectedTask?.size_breast}</td>
                      </tr>
                      <tr>
                        <td className="tb_td">Sleeve</td>
                        <td className="tb_td">{this.state.currentSelectedTask?.size_sleeve}</td>
                      </tr>
                      <tr>
                        <td className="tb_td">Shoulder</td>
                        <td className="tb_td">{this.state.currentSelectedTask?.size_shoulder}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

              </div>
              <div style={{ float: "right" }}>
                {this.state.currentProject.check_status === "completed" ? (
                  <Button
                    color="normal"
                    disabled={true}

                  >
                    완료된 프로젝트
                  </Button>
                ) : (
                  <div>
                    <Button
                      color="info"
                      onClick={() => {
                        this.updateProductStatus(this.state.data[0].idx, "accept");
                      }}
                    >
                      수락
                    </Button>
                    <Button
                      color="danger"
                      onClick={() => {
                        this.updateProductStatus(this.state.data[0].idx, "reject");
                      }}
                    >
                      제외
                    </Button>
                  </div>)}
              </div>
            </div>

          </div>)}



        <HeaderComponent signOut={this.props.cognito.signOut} setStage={this.props.setStage} stage={this.props.stage}></HeaderComponent>
        <div className="main_contents">
          <Container fluid>
            <Row>
              <div className="x_panel" style={{ alignItems: "center", display: "flex", justifyContent: "center" }}>
                <Col md={4}>

                  <Col md={2}>
                    <ButtonGroup>
                      <Button
                        color="info"
                        onClick={() => {
                          this.getProductData();
                        }}
                      >
                        Refresh
                      </Button>
                    </ButtonGroup>
                  </Col>
                  <Col md={3}>
                    <Input value={this.state.selectedMode} onChange={(e) => this.onValueChanged("selectedMode", e.target.value)} id="selectedMode" name="selectedMode" type="select">
                      <option value={"all"}>목록 선택(전체보기)</option>

                      <option value={"accept"}>수락</option>
                      <option value={"ready"}>검수 전</option>
                      <option value={"reject"}>제외</option>

                    </Input>
                    {/* <ButtonGroup>
											<Button
												color="primary"
												outline
												onClick={() => {
													this.toggleExcludeEvaluated();
												}}
												active={this.state.excludeEvaluated}
											>
												검수된 항목 제외
											</Button>
										</ButtonGroup> */}
                  </Col>
                  <Col md={3}>

                  </Col>
                  {/* <Col md={3}>
										<Input

											type="text"
											className="form-control"
											placeholder="search_seq"
											value={this.state.search_seq}
											onChange={(val) => {
												this.onValueChanged("search_seq", val.target.value);
											}}
										/>

									</Col> */}
                </Col>

                <Col md={4} style={{ alignItems: "center", display: "flex", fontSize: 25, color: "black", fontWeight: 800, justifyContent: "center" }}>
                  {(this.state.selectedProjectName == "all") ? "프로젝트를 선택해주세요" : `검수 준비: ${this.state.statusCounts.ready}, 수락: ${this.state.statusCounts.accept}, 제외: ${this.state.statusCounts.reject}`}
                </Col>
                <Col md={4}>

                  <Col md={3}>
                    <ButtonGroup>
                      <Button
                        color="primary"
                        onClick={() => {
                          this.exportToExcel();
                        }}
                      >
                        Export(Excel)
                      </Button>
                    </ButtonGroup>
                  </Col>
                  <Col md={3}>
                    <ButtonGroup>
                      <Button
                        color={(this.state.onDownloadAll != true) ? "primary" : (this.state.currentDownloadUrl) ? "primary" : "secondary"}
                        disabled={(this.state.onDownloadAll != true) ? false : (this.state.currentDownloadUrl) ? false : true}
                        onClick={() => {
                          this.downloadAll();
                        }}
                      >
                        {(this.state.onDownloadAll != true) ? "전체 다운로드" : (this.state.currentDownloadUrl) ? "다운로드 하려면 눌러주세요" : "다운로드 준비 중"}
                      </Button>
                    </ButtonGroup>
                  </Col>
                  <Col md={2}>
                    프로젝트 선택:
                  </Col>
                  <Col md={4}>
                    <Input value={this.state.selectedProjectName} onChange={(e) => this.onValueChanged("selectedProjectName", e.target.value)} id="selectedProjectName" name="selectedProjectName" type="select">

                      {this.state.project_list.map((item) => (
                        <option value={item.project_name}>{item.project_name}</option>
                      )
                      )}


                    </Input>
                  </Col>
                </Col>
              </div>
              <div className="x_panel" style={{ alignItems: "center", display: "flex", justifyContent: "center" }}>
                <div className="table-container">
                  <table>
                    <thead>
                      <tr>
                        <th>Idx</th>
                        <th>product_id</th>

                        <th>Original Image</th>

                        <th>현재 후보</th>
                        <th>컨트롤</th>
                        <th>검수상태</th>

                      </tr>
                    </thead>
                    <tbody>
                      {filteredData.map((item) => (
                        <tr
                          key={item.idx}


                        >
                          <td className="table-cell">{item.idx}</td>
                          <td className="table-cell">{item.product_id}</td>


                          <td className="table-cell">
                            <img
                              style={{ "max-width": "200px", "object-fit": "contain" }}
                              src={this.generateImageUrl(item, true)}
                              alt={item.filename}

                              onClick={(e) => this.handleResultClick(item, "input")}
                            />
                          </td>


                          <td className="table-cell">
                            <img
                              src={this.generateResultUrl(item)}
                              alt={`result-${item.filename}`}

                              onClick={(e) => this.handleResultClick(item, "result")}  // Handle Ctrl + Click
                            />
                          </td>
                          <td className="table-cell">
                            {this.state.currentProject?.check_status === "completed" ? (
                              <Button
                                color="normal"
                                disabled={true}

                              >
                                완료된 프로젝트
                              </Button>
                            ) : (
                              <>
                                <Button
                                  color="info"
                                  onClick={() => {
                                    this.updateProductStatus(item.idx, "accept");
                                  }}
                                >
                                  수락
                                </Button>
                                <br />
                                {item.check_status !== "reject" && (
                                  <Button
                                    color="danger"
                                    onClick={() => {
                                      this.updateProductStatus(item.idx, "reject");
                                    }}
                                  >
                                    제외
                                  </Button>
                                )}
                                <br />
                              </>
                            )}
                          </td>
                          <td className="discard-status" >{
                            this.getCurrentStatus(item.customer_check_status)


                          }

                          </td>

                        </tr>
                      ))}
                    </tbody>
                  </table>


                </div>
              </div>
            </Row>
          </Container>
        </div >
      </Fragment >
    );
  }
}

export default ProductPage;
